/* eslint-disable no-constant-condition */
import { all, call, fork, takeLatest, take, cancelled, cancel } from 'redux-saga/effects';
import { eventChannel } from 'redux-saga';
import { isEmpty } from 'lodash';

import {
  START_PRESENCE_NOTIFICATIONS ,
  STOP_PRESENCE_NOTIFICATIONS ,
} from 'constants/ActionTypes';
import { notifyPresence } from 'api/Presence';
import { CustomAction } from 'model/state';
import { PresencePayload } from 'actions';

const PRESENCE_INTERVAL = 30000; // 30 sec
const MAX_PRESENCE_TIME = 1800000; // max time sending presence - 30 mins

function createNotifyPresenceChannel() {
  return eventChannel((emitter) => {
    let total = 0;
    const iv = setInterval(() => {
      total += PRESENCE_INTERVAL;
      emitter(total < MAX_PRESENCE_TIME);
    }, PRESENCE_INTERVAL);
    // The subscriber must return an unsubscribe function
    return () => {
      clearInterval(iv);
    };
  });
}

function* startPresenceNotificationsRequest(action: CustomAction<PresencePayload>) {
  const payload = {
    locationIds: action.payload?.locationIds,
    deviceIds: action.payload?.deviceIds,
    appName: 'mud',
  };
  // creates the channel
  const presenceChannel = yield call(createNotifyPresenceChannel);

  try {
    try {
      yield call(notifyPresence, payload);
    } catch (error) {
      console.error(error);
    }

    let isActive = true;
    while (isActive) {
      isActive = yield take(presenceChannel);
      try {
        yield call(notifyPresence, payload);
      } catch (error) {
        console.error(error);
      }
    }
    presenceChannel.close();
  } finally {
    if (yield cancelled()) {
      presenceChannel.close();
    }
  }
}

function* startPresenceNotificationsWorker(action: CustomAction<PresencePayload>) {
  try {
    if (isEmpty(action.payload?.locationIds) && isEmpty(action.payload?.deviceIds)) {
      throw Error('Invalid Parameters');
    }
    const task = yield fork(startPresenceNotificationsRequest, action);

    yield take(STOP_PRESENCE_NOTIFICATIONS);
    yield cancel(task);
  } catch (error) {
    console.error('An Error occurred while starting presence notifications');
  }
}

export function* startPresenceNotificationsSaga() {
  yield takeLatest(START_PRESENCE_NOTIFICATIONS, startPresenceNotificationsWorker);
}

export default function* presenceSaga() {
  yield all([
    fork(startPresenceNotificationsSaga),
  ]);
}
